import { jsxs as i, jsx as s } from "react/jsx-runtime";
import o from "react";
import { b as c, c as g, L as f, R as l, a as m, d as L, D as y } from "../chunks/List.97cc6348.js";
import r from "styled-components";
const u = r.div.withConfig({
  displayName: "SlotStart",
  componentId: "sc-rkg096-0"
})(["display:flex;align-items:center;justify-content:flex-start;gap:var(--spacing-2x);"]), C = r.div.withConfig({
  displayName: "SlotEnd",
  componentId: "sc-rkg096-1"
})(["display:flex;align-items:center;justify-content:flex-end;margin-left:auto;"]), R = o.forwardRef(({
  children: e,
  ...n
}, a) => {
  const t = (d) => o.Children.toArray(e).filter((p) => p.props.slot === d);
  return /* @__PURE__ */ i(c, { ...n, ref: a, type: g.Line, "data-testid": "rango-list-content", "data-rango-component": "rango-list-content", "data-is-rango": !0, children: [
    /* @__PURE__ */ i(u, { children: [
      t("type"),
      t("label")
    ] }),
    /* @__PURE__ */ i(C, { children: [
      t("value"),
      t("action")
    ] })
  ] });
});
R.displayName = "RangoListContent";
const h = {
  ...f
};
Object.values(h);
const x = o.forwardRef(({
  label: e,
  description: n,
  ...a
}, t) => /* @__PURE__ */ s(l, { label: e, description: n, ...a, ref: t }));
x.displayName = "ListContentLabel";
const b = o.forwardRef(({
  ...e
}, n) => /* @__PURE__ */ s(m, { ...e, ref: n }));
b.displayName = "RangoListContentType";
const S = r(l).withConfig({
  displayName: "ListValue",
  componentId: "sc-pbkpxm-0"
})(["align-items:flex-end;", "{text-align:right;}", "{text-align:right;}"], L, y), w = o.forwardRef(({
  label: e,
  description: n,
  ...a
}, t) => /* @__PURE__ */ s(S, { label: e, description: n, ...a, ref: t }));
w.displayName = "ListContentValue";
export {
  h as ListContentType,
  R as RangoListContent,
  x as RangoListContentLabel,
  b as RangoListContentType,
  w as RangoListContentValue
};
